module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purchaseSalesDate"
    }
  }, [_vm._v("Pickup Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "purchaseSalesDate",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('input-mask', {
    ref: "tran",
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    staticClass: "dropDown",
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setWarehouseData) ? _c('Dropdown', {
    staticClass: "dropDown",
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 align-self-end"
  }, [_c('wearhouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Bill Amount")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.billAmount),
      callback: function($$v) {
        _vm.billAmount = $$v
      },
      expression: "billAmount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('InputText', {
    ref: "orderNo",
    staticClass: "form-control",
    model: {
      value: (_vm.customerName),
      callback: function($$v) {
        _vm.customerName = $$v
      },
      expression: "customerName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Contact No")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "primContact"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = $$v
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Secondary No")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "secContact"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.secondaryContactNumber),
      callback: function($$v) {
        _vm.secondaryContactNumber = $$v
      },
      expression: "secondaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "orderNo"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Receiver Name")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "orderNo"
    },
    model: {
      value: (_vm.receiverName),
      callback: function($$v) {
        _vm.receiverName = $$v
      },
      expression: "receiverName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Contact No")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "primContact"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.receiverContactNumber),
      callback: function($$v) {
        _vm.receiverContactNumber = $$v
      },
      expression: "receiverContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Secondary No")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "secContact"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.receiverSecondaryContactNumber),
      callback: function($$v) {
        _vm.receiverSecondaryContactNumber = $$v
      },
      expression: "receiverSecondaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "cus"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "id": "orderNo"
    },
    model: {
      value: (_vm.receiverAddress),
      callback: function($$v) {
        _vm.receiverAddress = $$v
      },
      expression: "receiverAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('TextArea', {
    staticClass: "textareaBox p-inputtext",
    attrs: {
      "cols": "6",
      "rows": "15",
      "id": "remarks"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer container-fluid"
  }, [_c('div', {
    staticClass: "btnWrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btnItm"
  }, [(this.deliveryEntry == undefined) ? _c('Button', {
    staticClass: " p-button p-component p-button-outlined p-button-danger",
    attrs: {
      "label": "Reset",
      "icon": "pi pi-refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")]) : _vm._e(), _vm._v(" "), (this.deliveryEntry != undefined) ? _c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "btnItm -excelUpload"
  }, [_c('label', {
    staticClass: "p-button p-component p-button-raised p-button-info",
    attrs: {
      "for": "imageUpload"
    }
  }, [_vm._v("Excel Upload ")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "imageUpload",
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileSelect
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnItm"
  }, [_c('Button', {
    staticClass: "p-button p-component",
    attrs: {
      "label": "Upload"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.uploadExcel.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnItm"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": !this.editing ? 'Save' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveDeliveryOrder.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btnItm"
  }, [(this.saved) ? _c('a', {
    staticClass: "btn btn-default pull-right"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btnItm"
  }, [(this.saved) ? _c('Button', {
    staticClass: "p-button-raised",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Generate PDF\n              ")]) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btnItm"
  }, [_c('a', {
    staticClass: "p-button p-component p-button-outlined text-center",
    attrs: {
      "download": "deliveryUplaodFormat.xlsx",
      "href": "../../../../static/excelFormat/upload format-BlueWagon.xlsx"
    }
  }, [_vm._v("Download format")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaadcc52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/delivery/deliveryEntryForm.vue
// module id = 2379
// module chunks = 0